module.exports = __webpack_public_path__ + "img/pulldown-default-hover.5d56a1de.svg";